import colors from './colors';

const maxWidth = 672;

/**
 * Theme configuration for Blue Shield of California
 */
const themeConfig = {
  inverse: false,
  palette: {
    primary: {
      main: colors.primary.main,
      secondary: colors.primary.secondary,
      contrastText: colors.text.primary,
    },
    secondary: {
      main: colors.secondary.main,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      error: colors.error.textColor,
      tertiary: colors.text.tertiary,
      success: colors.success.textColor,
      muted: colors.text.muted,
    },
    bgColor: {
      default: colors.background.default,
      disabled: colors.background.disabled,
      lightGray: colors.background.lightGray,
      error: colors.error.bgColor,
      darkGray: colors.background.darkGray,
      white: colors.text.tertiary,
      black: colors.text.primary,
    },
    border: {
      default: colors.border.default,
      error: colors.border.error,
      unselected: colors.border.unselected,
    },
  },
  fontFamily: {
    header: 'Fieldwork Geo',
  },
  typography: {
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 300,
      fontSize: '2rem',
      lineHeight: '38px',
    },
    h6: {
      fontWeight: 300,
      fontSize: '1.5rem',
      lineHeight: '28px',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: '24px',
      fontWeight: 300,
      lineSpacing: '24px',
    },
    body2: {
      fontSize: '1.125rem',
      lineHeight: '24px',
      fontWeight: 300,
      lineSpacing: '16px',
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        borderRadius: '4px',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        },
      },
      containedPrimary: {
        backgroundColor: colors.text.secondary,
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: colors.background.lightHover,
        },
      },
    },
    MuiCard: {
      root: {
        borderRadius: '8px',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: colors.background.lightBlue,
      },
    },
    MuiFormControlLabel: {
      root: {
        marginTop: 6,
        padding: '8px 12px',
        alignItems: 'flex-start',
        backgroundColor: `${colors.states.transparent} !important`,
        transition: 'none',
        '&:hover': {
          backgroundColor: `${colors.states.transparent} !important`,
        },
        '&.Mui-checked': {
          backgroundColor: `${colors.states.transparent} !important`,
        },
        '&:focus': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
          backgroundColor: `${colors.states.transparent} !important`,
        },
        '&.Mui-focusVisible': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
          backgroundColor: `${colors.states.transparent} !important`,
        },
        '&:focus-within': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
          backgroundColor: `${colors.states.transparent} !important`,
        },
      },
    },
    MuiRadio: {
      root: {
        color: `${colors.border.unselected} !important`,
        '&.Mui-checked': {
          color: `${colors.primary.main} !important`,
        },
        '&:hover': {
          backgroundColor: `${colors.states.transparent} !important`,
        },
        '&:focus': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
        },
        '&.Mui-focusVisible': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
        },
      },
    },
    MuiCheckbox: {
      root: {
        color: `${colors.border.unselected} !important`,
        '&.Mui-checked': {
          color: `${colors.primary.main} !important`,
        },
        '&:hover': {
          backgroundColor: `${colors.states.transparent} !important`,
        },
        '&:focus': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
        },
        '&.Mui-focusVisible': {
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
        },
      },
    },
  },
};

export { themeConfig, maxWidth };
